import { render } from "./BuySmsDialog.vue?vue&type=template&id=8880f2a0&scoped=true"
import script from "./BuySmsDialog.vue?vue&type=script&lang=js"
export * from "./BuySmsDialog.vue?vue&type=script&lang=js"

import "./BuySmsDialog.vue?vue&type=style&index=0&id=8880f2a0&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8880f2a0"]])

export default __exports__